// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-selection-list{
    display:flex;
    width:-moz-fit-content;
    width:fit-content;
}`, "",{"version":3,"sources":["webpack://./src/app/settings/datamodel/containerrest/mapping/forms/base.mapping.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,sBAAiB;IAAjB,iBAAiB;AACrB","sourcesContent":[".mat-selection-list{\n    display:flex;\n    width:fit-content;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
